<div class="main-container">
    <div class="container-fluid pt-3 mb-3 pb-3">
      
<div class="login">
    <div class="login-section">
        <div class="login-form">
            <div class="login-logo">
                <img src="../../../assets/images/control-logo.png" alt="">
                <span>Contractor Portal</span>
            </div>
            <h4 class="text-center">Create New Password</h4>
            <form [formGroup]="form">
            <div class="row">
                <div class="col-md-12 pb-3">
                    <mat-form-field class="example-form-field full-width" appearance="outline">
                        <mat-label>New Password</mat-label>
                        <input matInput type="password" maxlength="25" formControlName="newPassword"
                                        (keyup)="passwordstrength()" [errorStateMatcher]="matcher" autocomplete="off">
                                    <mat-error *ngIf="errorHandling('newPassword', 'required')">
                                        New password is required
                                    </mat-error>
                                    <mat-error *ngIf="errorHandling('newPassword', 'isPassword')">
                                        Minimum six characters, at least one uppercase, one lowercase, one number and
                                        one
                                        special character
                                    </mat-error>
                                    <mat-hint *ngIf="strengthMsg" [ngStyle]={color:msgColor}>{{strengthMsg}}</mat-hint>
                    </mat-form-field>
                </div>
                <div class="col-md-12 pb-2">
                    <mat-form-field class="example-form-field full-width" appearance="outline">
                        <mat-label>Confirm Password</mat-label>
                        <input matInput type="password" maxlength="25" formControlName="confirmPassword"
                                        [errorStateMatcher]="matcher" autocomplete="off">
                                    <mat-error *ngIf="errorHandling('confirmPassword', 'required')">
                                        Confirm Password is required
                                    </mat-error>
                                    <mat-error *ngIf="errorHandling('confirmPassword','NoPassswordMatch')">
                                        Password does not match
                                    </mat-error>
                    </mat-form-field>
                </div>
                <div class="col-md-12 mt-2">
                    <button mat-raised-button color="primary" type="submit" class="full-width" (click)="submit()"> Submit </button>
                </div>
            </div>
            </form>
        </div>
    </div>
</div>
</div>
</div>